$(document).ready(function () {
  console.log("load the page");

  //========Search[Header]
  new Typed(".typed_desk", {
    strings: ["Search Here…", "Search Here…"],
    typeSpeed: 120,
    delaySpeed: 120,
    loop: true,
  });

  new Typed(".header__content-mobile .typed_desk", {
    strings: ["Search Here…", "Search Here…"],
    typeSpeed: 120,
    delaySpeed: 120,
    loop: true,
  });

  //========Product Slider
  $(".product_slider_inner").slick({
    dots: true,
    infinite: false,
    arrows: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 3000,
        },
      },
    ],
  });

  //============Tabify
  $(".featured_collection li").click(function () {
    var tab_id = $(this).attr("data-tab");
    $(".featured_collection li").removeClass("hover_active");
    $(this)
      .parents(".product_tabify")
      .find(".product_tab_details")
      .removeClass("active")
      .fadeOut("fast");
    $(this).addClass("hover_active");
    $("#" + tab_id)
      .fadeIn(1000)
      .addClass("active");
  });

  var dropdownItems = document.querySelectorAll(
    ".variant-dropdown .dropdown-menu .dropdown-item"
  );
  var dorpdownTitle = document.querySelector(
    ".dropdown-toggle .variant-dropdown-value"
  );
  var dorpdownImage = document.querySelector(
    ".dropdown-toggle .drop_variant_color .variant-color-value"
  );

  dropdownItems.forEach(function (item) {
    item.addEventListener("click", function () {
      console.log("click");
      dropdownItems.forEach(function (item) {
        item.classList.remove("active");
      });
      this.classList.add("active");
    });
  });

  // from swatch to dropdown
  const colorSwatches = document.querySelectorAll(".product__color-swatch");

  // Find initially selected color
  let selectedColor;
  colorSwatches.forEach(function (swatch) {
    if (swatch.classList.contains("selected")) {
      selectedColor = swatch.getAttribute("data-option-value");
    }
    swatch.addEventListener("click", () => {
      selectedColor = swatch.getAttribute("data-option-value");
      if (selectedColor) {
        syncDropdown(selectedColor);
      }
    });
  });

  // Sync dropdown with initially selected color
  if (selectedColor) {
    console.log(selectedColor, "==>selectedColor ");
    syncDropdown(selectedColor);
  }

  // Function to synchronize dropdown with selected color
  function syncDropdown(selectedColor) {
    dropdownItems.forEach(function (item) {
      const dropdownValue = item.getAttribute("data-val");
      if (dropdownValue === selectedColor) {
        // Add 'active' class to the dropdown item
        item.classList.add("active");
        dorpdownTitle.textContent = dropdownValue;
        let imageStyle = item
          .querySelector(".variant_color_name")
          .getAttribute("style");
        dorpdownImage.setAttribute("style", imageStyle);
      } else {
        // Remove 'active' class from other dropdown items
        item.classList.remove("active");
      }
    });
  }
});

$(".variant-dropdown .dropdown-menu .dropdown-item").click(function () {
  var selectedValue = $(this).data("val");
  console.log("CLICK==>", selectedValue);
  var variantColorNameStyle = $(this).find(".variant_color_name").attr("style");

  $(".variant-dropdown .dropdown-toggle .variant-dropdown-value").text(
    selectedValue
  );

  $(".variant-dropdown .dropdown-toggle .variant-color-value").attr(
    "style",
    variantColorNameStyle
  );

  $(".product__color-swatches")
    .find('button[data-option-value="' + selectedValue + '"]')
    .trigger("click");
});

// TOP COLLECTION SEC SLIDER

$(document).ready(function () {

function initSlickSlider() {
  let $slider = $(".home_categoriers_wrapper");

  $slider.slick({
    dots: false,
    infinite: false,
    arrows: true,
    speed: 300,
    slidesToShow: 5,
    slidesToScroll: 1,
    width: "auto",
    responsive: [
      {
        breakpoint: 991,
        settings: { slidesToShow: 4 },
      },
      {
        breakpoint: 767,
        settings: { 
          slidesToShow: 3,
          arrows: false,
          slidesToScroll: 3,
        },
      },
    ],
  });

  function progress(sliders) {
    sliders.each(function () {
      var slider = $(this);
      var $progressBar = slider.closest(".custom_collection_block").find(".progress");

      var slickObj = slider.slick("getSlick");
      var totalSlides = slickObj.slideCount;
      var slidesToShow = slickObj.options.slidesToShow;

      // Max movement point
      var maxSlide = totalSlides - slidesToShow;

      // Initial % = visible slides / total slides
      var initPercent = (slidesToShow / totalSlides) * 100;
      $progressBar.css("--progress", initPercent + "%");

      slider.on("beforeChange", function (event, slick, currentSlide, nextSlide) {
        var calc = ((nextSlide + slidesToShow) / totalSlides) * 100;
        if (calc > 100) calc = 100;
        $progressBar.css("--progress", calc + "%");
      });
    });
  }

  progress($slider);
}

  initSlickSlider();
  $(window).on("resize", function () {
    initSlickSlider();
  });
  $(window).on("load", function () {
    initSlickSlider();
  });
  //============Logo Slider
  $(".featured_slider").slick({
    dots: false,
    infinite: true,
    arrows: false,
    speed: 300,
    slidesToShow: 7,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1441,
        settings: {
          slidesToShow: 6,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
    ],
  });
});

// =================================

document.addEventListener("DOMContentLoaded", function () {
  const track = document.querySelector(".collection-list__collections .scroll-slider__slider");
  const items = document.querySelectorAll(".collection-item");
  const progress = document.querySelector(".collection-progressbar-fill");

  if (!track || items.length === 0 || !progress) return;

  function updateProgress() {
    const itemWidth = items[0].offsetWidth;
    const gap = 0;
    const totalItems = items.length;

    const totalWidth = (itemWidth * totalItems) + (gap * (totalItems - 1));
    const maxScroll = totalWidth - track.clientWidth;

    // 🔥 Jitne items screen pe visible hain
    const visibleItems = track.clientWidth / (itemWidth + gap);

    // 🔥 Starting base progress (visible portion)
    const baseProgress = (visibleItems / totalItems) * 100;

    if (maxScroll <= 0) {
      progress.style.width = "100%";
      return;
    }

    // 🔥 Scroll progress
    const scrollPercent = (track.scrollLeft / maxScroll) * (100 - baseProgress);

    // 🔥 Final progress = visible + scroll
    const finalProgress = baseProgress + scrollPercent;

    progress.style.width = finalProgress + "%";
  }

  track.addEventListener("scroll", updateProgress);
  window.addEventListener("resize", updateProgress);
  updateProgress();
});
